import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Outer = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;
  padding: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: ${layout.horizontalPadding};
    box-sizing: border-box;
  }
`;

export const OuterSticky = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;
  padding: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: ${layout.horizontalPadding};
    box-sizing: border-box;
    position: sticky;
    top: 0;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: var(--side-image-mobile-height, 380px);
  overflow: hidden;
  border-radius: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: var(--side-image-desktop-height, calc(100% - 40px));
    border-radius: 20px;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${colors.lightGrey};
  border-radius: inherit;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: ${space[5]};
  background: linear-gradient(rgba(0, 0, 0, 0.35), transparent);
  border-radius: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[6]};
    border-radius: 20px 20px 0 0;
  }
`;

export const BadgeContainer = styled.div`
  position: absolute;
  bottom: ${layout.horizontalPadding};
  left: ${space[4]};
  z-index: 2;

  @media (min-width: ${layout.desktopBreakpoint}) {
    bottom: ${space[5]};
    left: ${space[5]};
  }
`;

export const DefaultBadge = styled.span`
  display: inline-block;
  background: ${colors.sale};
  color: ${colors.white};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  padding: 6px 14px;
  border-radius: ${space[1]};
`;
